import { CadenceListViewModel, CadenceUnarray } from 'cadence';

export type CadenceListViewRow<T extends CadenceListViewModel> = CadenceUnarray<
  T['_rows$']['value']
>;
